import React from 'react'
import {
  makeStyles,
  createStyles,
  Box,
  List,
  ListItem,
  ListItemText,
  Typography,
  Divider,
  Link as MuiLink,
} from '@material-ui/core/'
import { useTranslation } from 'react-i18next'
import { SITE_MATE_DATA, AGREEMENT_ID_MAP } from 'src/utils/constant'
import { ReactComponent as RightArrowIcon } from 'src/mobile/assets/icons/arrow-ios-right.svg'
import { Link } from 'react-router-dom'
import { useImageTranslation } from 'src/hooks'

const useStyles = makeStyles((theme) =>
  createStyles({
    arrowIcon: {
      width: 20,
      height: 20,
      '& path': {
        fill: theme.palette.grey[200],
      },
    },
  }),
)
const ProfileAccount = () => {
  const classes = useStyles()
  const { t, i18n } = useTranslation()
  const [tImage] = useImageTranslation()

  const ABOUT_LIST = [
    {
      label: 'glossary.follow_us',
      path: '/follow-us/',
    },
    {
      label: 'glossary.contact_us',
      path: '/contact-us/',
    },
    {
      label: AGREEMENT_ID_MAP.privacyPolicy.label,
      path: `/agreement/${AGREEMENT_ID_MAP.privacyPolicy.id}`,
    },
    {
      label: AGREEMENT_ID_MAP.clubPolicy.label,
      path: `/agreement/${AGREEMENT_ID_MAP.clubPolicy.id}`,
    },
    {
      label: AGREEMENT_ID_MAP.personalInfoCollectProve.label,
      path: `/agreement/${AGREEMENT_ID_MAP.personalInfoCollectProve.id}`,
    },
    {
      label: 'glossary.know_more_about_prophecy',
      path: `${process.env.REACT_APP_WEBSITE_URL}/${i18n.language}${SITE_MATE_DATA.CAMPAIGN_PAGE}`,
    },
  ]

  return (
    <Box mt="1px" bgcolor="background.paper">
      <Box mx="auto" my={3} width={96}>
        <img width="100%" height="100%" src={tImage('logo', 'png')} alt="take2 logo" />
      </Box>
      <Box mx={2}>
        <List disablePadding>
          {ABOUT_LIST?.map((item, index) => (
            <React.Fragment key={item.label}>
              {index === ABOUT_LIST.length - 1 ? (
                <ListItem button href={item.path} underline="none" target="_blank" component={MuiLink}>
                  <ListItemText
                    primary={
                      <Typography variant="h5" noWrap>
                        <Box component="span" color="grey.900">
                          {t(item.label)}
                        </Box>
                      </Typography>
                    }
                  />
                  <RightArrowIcon className={classes.arrowIcon} />
                </ListItem>
              ) : (
                <ListItem key={item.label} button to={`/${i18n.language}${item.path}`} component={Link}>
                  <ListItemText
                    primary={
                      <Typography variant="h5" noWrap>
                        {t(item.label)}
                      </Typography>
                    }
                  />
                  <RightArrowIcon className={classes.arrowIcon} />
                </ListItem>
              )}
              <Divider />
            </React.Fragment>
          ))}
        </List>
      </Box>
    </Box>
  )
}

export default ProfileAccount
